
module dgExceptions {

    class HttpErrorHandlerInterceptor {
        constructor(
            private $rootScope: ng.IRootScopeService,
            private $q: ng.IQService,
            private $timeout: ng.ITimeoutService) {

        }

        requestError = (rejection) => {

        }

        responseError = (rejection: ng.IHttpPromiseCallbackArg<dg.restfulApi.ErrorResult>) => {
            //skip 401 message display, it is handled by adal frmework
            if (!!rejection && !!rejection.status && rejection.status != 401) {
                //TODO: create DgEvents enum
                this.$timeout(() => {
                    this.$rootScope.$broadcast('DgEvents.HTTPError', rejection);
                });
            }
            return this.$q.reject(rejection);
        }
    }

    angular.module('dg.exceptions')
        .service('httpErrorHandlerInterceptor', HttpErrorHandlerInterceptor);
}